import React from 'react'
// libs
import styled from 'styled-components'
// icons
import SwitchIconOrigin from 'src/icons/properties/switch.svg'
import DateIconOrigin from 'src/icons/properties/date.svg'
import PicklistIconOrigin from 'src/icons/properties/drop-down.svg'
import LabelIconOrigin from '@mui/icons-material/Label'
import TextIconOrigin from 'src/icons/properties/text.svg'
import NumberIconOrigin from '@mui/icons-material/Numbers'
import TagIconOrigin from 'src/icons/properties/tags.svg'
import LookupIconOrigin from 'src/icons/properties/lookup.svg'
import AttachmentIconOrigin from 'src/icons/add-attachment.svg'
import SectionIconOrigin from '@mui/icons-material/ViewStream'
import JsonIconOrigin from '@mui/icons-material/Assignment'
import TableIconOrigin from '@mui/icons-material/TableChart'
import MatrixIconOrigin from '@mui/icons-material/Apps'
import FormIconOrigin from '@mui/icons-material/Dashboard'
import LocationIconOrigin from '@mui/icons-material/LocationOn'
import LinkedFormIconOrigin from 'src/icons/document-link.svg'
import LinkIconOrigin from '@mui/icons-material/Link'
import ArticleIconOrigin from '@mui/icons-material/Article'
// themes
import colors from '../colors'
// utils
import { size } from 'polished'

const SwitchIcon = styled(SwitchIconOrigin)`
  ${size('20px')};
`

const DateIcon = styled(DateIconOrigin)`
  ${size('20px')};
`

const PicklistIcon = styled(PicklistIconOrigin)`
  ${size('20px')};
`

const TextIcon = styled(TextIconOrigin)`
  ${size('20px')};
`

const NumberIcon = styled(NumberIconOrigin)`
  ${size('20px')};
`

const LookupIcon = styled((props) => <LookupIconOrigin {...props} />)`
  ${size('20px')};
`

const TagIcon = styled(TagIconOrigin)`
  ${size('20px')};
`

const JsonIcon = styled((props) => <JsonIconOrigin {...props} />)`
  && {
    ${size('20px')};
  }
`

const TableIcon = styled((props) => <TableIconOrigin {...props} />)`
  && {
    ${size('20px')};
  }
`

const MatrixIcon = styled((props) => <MatrixIconOrigin {...props} />)`
  && {
    ${size('20px')};
  }
`

const LabelIcon = styled(LabelIconOrigin)`
  ${size('20px')};
`

const AttachmentIcon = styled(AttachmentIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

const FormIcon = styled(FormIconOrigin)`
  && {
    ${size('20px')};

    path {
      fill: ${colors.black};
    }
  }
`

const LinkedFormIcon = styled(LinkedFormIconOrigin)`
  && {
    ${size('20px')};

    path {
      fill: ${colors.black};
    }
  }
`

const SectionIcon = styled(SectionIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

const LocationIcon = styled(LocationIconOrigin)`
  ${size('20px')};
`

const RecordLinksIcon = styled(LinkIconOrigin)`
  && {
    ${size('20px')};
  }
`

const ParentFieldsIcon = styled(ArticleIconOrigin)`
  && {
    ${size('20px')};
  }
`

export {
  DateIcon,
  JsonIcon,
  LookupIcon,
  NumberIcon,
  PicklistIcon,
  SwitchIcon,
  TagIcon,
  TextIcon,
  TableIcon,
  MatrixIcon,
  LabelIcon,
  AttachmentIcon,
  FormIcon,
  SectionIcon,
  LocationIcon,
  LinkedFormIcon,
  RecordLinksIcon,
  ParentFieldsIcon
}
